import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  const location = useLocation();
  const showFooter = location.pathname !== '/Login';

  return (
    <>
      <Header />
      <main style={{ paddingTop: '80px' }}>
        {children}
      </main>
      {showFooter && <Footer />}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
